import BigNumber from 'bignumber.js'
import { ChainId } from '@nominex/nomiswap-sdk'
import { BIG_TEN } from 'config/constants/bigNumber'
import { getFarmingHelperContract, getSupplierContract } from 'utils/contractHelpers'
import { SerializedFarm } from 'state/types'

const fetchFarmSupplyRates = async (farms: SerializedFarm[], chainId: ChainId) => {
  const farmingHelperContract = getFarmingHelperContract(chainId)

  return Promise.all(
    farms.map(async ({ stakingServiceAddress, supplierAddress, earningToken, pid }) => {
      let tokensPerSecRaw = null

      if (supplierAddress) {
        const supplierContract = await getSupplierContract(supplierAddress)
        tokensPerSecRaw = await supplierContract.nmxPerSecond()
      } else {
        tokensPerSecRaw = await farmingHelperContract.currentSupplyRate(stakingServiceAddress)
      }

      return {
        pid,
        // eslint-disable-next-line no-underscore-dangle
        tokensPerSec: new BigNumber(tokensPerSecRaw._hex).div(BIG_TEN.pow(earningToken.decimals)).toJSON(),
      }
    }),
  )
}

export default fetchFarmSupplyRates
